import type {
    ActivityAreaResource,
    AddressResource,
    DateAsString,
    ExperienceResource,
    ExperienceSkillResource,
    LogoResource,
} from '~/types/api-raw-types';

export class Experience {
    area: ActivityAreaResource;
    asFreelance: boolean;
    commentCount: number;
    company: string;
    companyId: string;
    currentJob: boolean;
    description: string;
    endDate?: DateAsString;
    id: string;
    location?: AddressResource;
    logo: LogoResource;
    organizationName: string;
    recommendationCount: number;
    startDate: DateAsString;
    missionId?: string;
    skills: ExperienceSkillResource[];
    title: string;

    constructor(params: ExperienceResource) {
        this.area = params.area;
        this.asFreelance = params.asFreelance;
        this.commentCount = params.commentCount;
        this.company = params.company;
        this.companyId = params.companyId;
        this.currentJob = params.currentJob;
        this.description = params.description;
        this.endDate = params.endDate || undefined;
        this.id = params.id;
        this.location = params.location;
        this.logo = params.logo;
        this.organizationName = params.organizationName;
        this.recommendationCount = params.recommendationCount;
        this.startDate = params.startDate;
        this.missionId = params.missionId;
        this.skills = params.skills;
        this.title = params.title;
    }

    toJSON() {
        return {
            ...this,
        };
    }
}

export class Experiences {
    items: Experience[];

    constructor(params: ExperienceResource[]) {
        this.items = params.map((experienceResource) => new Experience(experienceResource));
    }

    toJSON() {
        return {
            ...this,
        };
    }
}
